export const REACTIVATE_CARD_REQUIRED_ERROR_CODE = 4005;
